
import { useState,useEffect } from 'react'
import './styles/PanelBuzon.css'
import Search from '../generales/Search';
import Action from '../Action';
import Modal from 'react-modal';
import BuzonList from './BuzonList';
import LoadSimple from '../LoadSimple';
import TableBuzon from './TableBuzon';
import InfoBuzon from './InfoBuzon';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
import Paginador from '../generales/Paginador';
const CreateBuzonModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#ffffff !important',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'50%',
      height:'70%',
      padding:'20px'
    },
  };
const PanelBuzon=({server,languaje,mode,handleShowPopup})=>{
  const [CreateBuzonModalOpen, setCreateBuzonModalOpen] =useState(false);
  const [dataUsers,setDataUsers]=useState({data:[],loading:true,error:null})
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [devices,setDevices]=useState({data:[],loading:true,error:null});
  const [searchResult, setSearchResult] = useState(null);
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState(null);
  const [dataBuzon,setDataBuzon]=useState([]);
  const [loadingBuzon,setLoadingBuzon]=useState(false);
  const [errorBuzon,setErrorBuzon]=useState(null);
  const [Buzonelected,setBuzonelected]=useState([])
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const pages = parseInt(dataList.length / limitList) + 1;
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, '0');
    const horas = String(ahora.getHours()).padStart(2, '0');
    const minutos = String(ahora.getMinutes()).padStart(2, '0');
  
    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };
  const handleSearch = (query) => {
      // Aquí puedes realizar la búsqueda usando el valor de 'query'
      // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
      setSearchResult(`Resultados para: ${query}`);
    }
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateBuzonModalOpen(true)
  }
  function closCreateBuzonModal() {
    setEditActive(false)
    setCreateBuzonModalOpen(false);
  }
  const handleChangEdit=(Buzon)=>{
    setEditActive(true)
    buscar_Buzon(Buzon.Buzonid)
  }

  const buscar_Buzon=()=>{
      
      
      // setLoadingBuzon(true)
        const fetchDataPost = async () => {
          
       try {
         const response = await fetch(server.url+'/api/v1/cassia/cis_v2/authorizations/pending', {
             method: 'GET',  
             headers: {
               'Content-Type': 'application/json',
               'accept': 'application/json',
               'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
             },
           });
         if (response.ok) {
           const data1 = await response.json();
           setDataUsers(data1)
           // setCreateBuzonModalOpen(true)
         } else {
           const data1 = await response.json();
           throw new Error('Error en la solicitud');
         }
       } catch (error) {
            console.error(error);
          }
        };
    
        fetchDataPost();
      
  }
  const regresar_Buzon=()=>{
      setBuzonelected([])
  }

  const generatePDF = () => {
    
    const input = document.getElementById('content');

  // Guardar el estado actual de visibilidad de los elementos que deseas ocultar
  const originalDisplay = [];
  const elementsToHide = input.querySelectorAll('.hiddenPDF');
  elementsToHide.forEach(element => {
    originalDisplay.push(element.style.display);
    element.style.display = 'none';
  });

  html2canvas(input)
    .then((canvas) => {
      // Restaurar el estado original de visibilidad
      elementsToHide.forEach((element, index) => {
        element.style.display = originalDisplay[index];
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG',10, 10, 190, 100);
      pdf.save('Buzon-'+obtenerFechaActualLocal()+'.pdf');
    });
  }
  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };

  return (
      <>
      <div className='head-cis'>
              <div className='title-cis'>
              <Search
                  searchResults={searchResults}
                  setSearchResults={setSearchResults}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  onSearch={handleSearch}
                  dataObject={dataUsers.data}
                  setDataObject={setDataUsers}
                  searchResult={searchResult}
                  setSearchResult={setSearchResult}
                  languaje={languaje}
                />
        <div className={"cont-result-registers"+mode}>
       
                <p style={{  textAlign: "center" }}>
                  &nbsp;
                  {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                    dataList.length +
                    ") " 
                    }
                </p> 
        </div>
        <div className="cont-buttons-panel">
                
                  {/* <Action
                  disabled={false}
                  origen="Azul"
                  titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                  action={crear}
                /> */}
                
               
              </div>
              </div>
              
              
          </div>
          <div className='cont-cis'>
         
          <>
      <div className='main-panel-cis'>
      <div className="compact-content-portafolio">
      <div className={"content-portafolio-head"+mode}>
            
            <div className="cont-excels-buttons-portafolio" style={{position:'absolute',left:'0%',width:'15%'}}>
        
                   
                    <div className="" style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'center'}}>
                    
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                        <img
                  className="img-dwnld-portafolio"
                  style={{width:'20px'}}
                  src={"/iconos/refresh.png"}
                  name="refresh"
                  onClick={()=>buscar_Buzon()}
                />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                      {'Volver a cargar'}
                      </div>
                    </div>
               </div>
      </div>
          <div className='content-portafolio'>
              
             
              <div className='cont-portafolio-table'>
              <div className='content-card-portafolio' id='content'>
                {
                  
                  <>
                  
                            <TableBuzon buscar_Buzon={buscar_Buzon}handleShowPopup={handleShowPopup} startLimit={startLimit} pageActual={pageActual} limitList={limitList} languaje={languaje} mode={mode} dataBuzon={dataBuzon} setDataBuzon={setDataBuzon} editActive={editActive} Buzonelected={Buzonelected} setBuzonelected={setBuzonelected} registerIsValid={registerIsValid} searchResults={searchResults} setSearchResults={setSearchResults} searchTerm={searchTerm} setSearchTerm={setSearchTerm} dataUsers={dataUsers} setDataUsers={setDataUsers} server={server} setRegisterIsValid={setRegisterIsValid} setData={setData} setLoading={setLoading} setError={setError}  handleChangEdit={handleChangEdit} devices={devices}></TableBuzon>
                            
                          
                  </>
                }
                            
                              
                          </div>
              </div>
          </div>
          <div className={"content-portafolio-footer"+mode}>
        <div className="cont-display-paginador">
                  <Paginador  pages={pages}
                              pageActual={pageActual}
                              setPageActual={setPageActual}
                              mode={mode}></Paginador>
        </div>
        <div className="cont-display-paginador">
          <div className={"cont-half-display-paginador"+mode}>
                    
          <div>
    <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
    <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
      <option value={10}>10</option>
      <option value={50} >50</option>
      <option value={100}>100</option>
      <option value={500}>500</option>
      <option value={1000}>1000</option>
    </select>

    
  </div>
          </div>
          <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                        ?  parseInt(pageActual ) * parseInt(limitList)
                        : dataList.length) +
                      ")  "+lang[languaje]['de']+" " +
                      dataList.length +
                      " "+lang[languaje]['resultados']}
                    </p>
                
          </div>
        </div>  
                  
      </div>
          </div>
      </div>
     
  </>
          </div>
      </>
  )
}

export default PanelBuzon